import { AxiosError } from "axios";
import { apiFatalsMetricsPublisher } from "src/utils/metricUtils";
import { cognitoAuthenticate, getEmployeeAlias } from "src/auth/cognito-auth"; // Import a utility function to get alias
import { katalLoggerError } from "src/logger";
import { apiSuccessMetricsPublisher as countMetricPublisher } from 'src/utils/metricUtils'
import { IS_AFTX_REQUEST, isAftxDomain, showAftxErrorToast } from "src/utils/aftx-utils";
import { dispatchAuthError } from "src/components/helpers/auth-error-modal/auth-error-modal";
import { IS_FC_MENU_REQUEST } from "src/utils/fc-utils";

export default function AxiosResponseError(error: AxiosError): any {
  let alias:any;
  if(!(IS_AFTX_REQUEST|| IS_FC_MENU_REQUEST)){
     alias = getEmployeeAlias();
  }

  const status = error.response?.status;
  const errorResponseData = error.response?.data as any;
  if (403 === status && ['HELIS_AUTH', 'HELIS_SOLUTIONS_AUTH'].includes(errorResponseData?.errorType)) {
    countMetricPublisher.publishCounter(errorResponseData.errorType, 1);
    katalLoggerError(
      window.location.href,
      `${errorResponseData.errorType} error`,
      { alias, status, errorResponseData }
    );
    dispatchAuthError(errorResponseData.team, errorResponseData.errorType);
    return Promise.reject(error);
  }

  if ([401, 403].includes(status as number)) {
    // Possible scenario: Token has been tampered.
    // Expired tokens are refreshed before this point.
    // If not handled here, the user would see a generic error instead of being redirected to re-authenticate.
    katalLoggerError(
      window.location.href,
      "Authentication error, redirecting to login:",
      {
        alias,
        status,
        errorResponseData,
      }
    );
    countMetricPublisher.publishCounter('4xx-redirected', 1)
    cognitoAuthenticate(true);
  }
  
  // Function to format error message with status, requestId and alias
  const formatErrorMessage = (message: string): string => {
    return `${message}${status ? ` [Status: ${status}]` : ''}${alias ? ` [User: ${alias}]` : ''}`;
  };

  let customMessage: string = errorResponseData ? formatErrorMessage(JSON.stringify(errorResponseData)) : formatErrorMessage("An unexpected error occurred");

  status ? apiFatalsMetricsPublisher.publishCounterMonitor(String(status), 1) : apiFatalsMetricsPublisher.publishCounterMonitor("OtherError", 1);


  // Creating a new error instance with all properties copied
  const newError = { ...error, message: customMessage, status } as AxiosError;

  return Promise.reject(newError);
}
